import { BehaviorSubject } from 'rxjs';

interface NavigationState {
  isReadyToGoToNextStep: boolean;
}
const initialNavigationState = { isReadyToGoToNextStep: false };
const navigationState$ = new BehaviorSubject<NavigationState>(initialNavigationState);

export const updateNavigationState = (state: NavigationState): void => {
  navigationState$.next(state);
};

export const navigationState = navigationState$.asObservable();
